import styled from "styled-components";

export const ActivityFormQuizNoMemberContainerStyled = styled.div``;
